import { theme } from '@branchjs/neo-components';
import { css } from '@emotion/css';

const container = css`
  display: flex;
  gap: ${theme.spacing(1)};
  justify-content: right;
`;

const buttonWrapper = css`
  background-color: ${theme.palette.common.white};
  border-radius: 8px;
`;

export const ingestionButtonStyles = { container, buttonWrapper };
